<template>
  <div class="platform-list">
    <div v-for="platform in platforms" :key="platform" class="badge">
      <ts-icon :icon="platform" size="x-small" color="#6d7587" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.platform-list {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;

  > * {
    margin-left: -8px;
  }
}

.badge {
  width: 32px;
  height: 32px;
  border-radius: 32px;

  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.32);
  box-shadow: -5px -5px 10px 0 rgba(250, 251, 255, 0.8), 5px 5px 10px 0 rgba(166, 171, 189, 0.48);

  font-family: Roboto;
  font-size: 12px;
  color: #6d7587;

  display: flex;
  justify-content: center;
  align-items: center;
  cursor: default;
}
</style>

<script>
export default {
  props: {
    platforms: {
      type: Array,
      default: () => []
    }
  }
};
</script>
